/**
 * The settings sections, grouped the way the mobile list shows them.
 * Kept apart from the markup so the desktop nav can move onto the same list
 * without the two drifting.
 */
export const SETTINGS_GROUPS = [
	{
		label: 'Account',
		items: [
			{ tab: 'general', path: '/settings/profile', label: 'Profile' },
			{ tab: 'security', path: '/settings/security', label: 'Security' },
			{ tab: 'devices', path: '/settings/devices', label: 'Devices' },
		],
	},
	{
		label: 'Plan & billing',
		items: [
			{ tab: 'subscription', path: '/settings/subscription', label: 'Subscription' },
			{ tab: 'team', path: '/settings/team', label: 'Team' },
		],
	},
	{
		label: 'Alerts',
		items: [{ tab: 'telegram', path: '/settings/telegram', label: 'Telegram' }],
	},
	{
		label: 'Email',
		items: [{ tab: 'email', path: '/settings/email', label: 'Email & Templates' }],
	},
]

const TITLES = SETTINGS_GROUPS.reduce((titles, group) => {
	group.items.forEach(item => {
		titles[item.tab] = item.label
	})
	return titles
}, {})

export function sectionTitle(tab) {
	return TITLES[tab] || 'Settings'
}
